import {
    GtpProvisionEvent,
    GtpWalletInfoResult,
    postMessageRN,
    runningInRNWebView,
    WebToRNAction,
} from '@eika-infrastruktur/mobilbank-lib';

import {
    AndroidDigitalWalletCard,
    Card,
    CardType,
    DigitalWalletSignResponse,
    KredittbankenWalletProvisionData,
} from '@generated-types';
import { cardTypeGet, cardTypePost } from '@utils/query-utils';

import { REST_BASE_URL } from '../../../react-query/common';

export const fetchDigitalWalletEligibleCards = async (walletInfoResult: GtpWalletInfoResult, type: CardType) => {
    const params = {
        clientAppId: walletInfoResult.bundleId,
        clientDeviceId: walletInfoResult.deviceStableHardwareId,
        clientWalletAccountId: walletInfoResult.activeWalletId,
        type,
    };

    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => searchParams.append(key, value));

    return cardTypeGet(type)<AndroidDigitalWalletCard[]>(`${REST_BASE_URL}/wallets/google-pay`, searchParams);
};

export const getGooglePayProvisionOPCWithoutSigning = async (card: Card, walletInfoResult: GtpWalletInfoResult) => {
    const { id } = card;

    const params = {
        clientAppId: walletInfoResult.bundleId,
        clientDeviceId: walletInfoResult.deviceStableHardwareId,
        clientWalletAccountId: walletInfoResult.activeWalletId,
    };

    // CHANGE THAT
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => searchParams.append(key, value));

    const provisionData = await cardTypePost(card.type)<KredittbankenWalletProvisionData>(
        `${REST_BASE_URL}/wallets/google-pay/${id}/unsigned`,
        params,
        searchParams,
    );

    postMessageRN({
        action: WebToRNAction.GTP_PUSH_PROVISION,
        payload: provisionData as GtpProvisionEvent,
    });
};

// Starts a signing process to get masked provision data (OPC)
export const getGooglePayProvisionOPCWithSigning = async (
    card: Card,
    walletInfo: GtpWalletInfoResult,
    signingData: DigitalWalletSignResponse,
) => {
    const params = {
        clientAppId: walletInfo.bundleId,
        clientDeviceId: walletInfo.deviceStableHardwareId,
        clientWalletAccountId: walletInfo.activeWalletId,
        walletType: card.type,
        cardType: card.type,
    };

    const searchParams = new URLSearchParams(params);

    const provisionData = await cardTypeGet(card.type)<KredittbankenWalletProvisionData>(
        `${REST_BASE_URL}/dynamic-links/${signingData.dynamicLinkId.value}/android-wallet-provision-data`,
        searchParams,
    );

    postMessageRN({
        action: WebToRNAction.GTP_PUSH_PROVISION,
        payload: provisionData as GtpProvisionEvent,
    });
};

export const startGoogleWalletSigning = async (card: Card) =>
    cardTypePost(card.type)<DigitalWalletSignResponse>(`${REST_BASE_URL}/wallets/google-pay/${card.id}`).then(
        (data) => {
            if (runningInRNWebView && data.redirectUrl) {
                postMessageRN({
                    action: WebToRNAction.OPEN_BROWSER_CALLBACK,
                    payload: { uri: data.redirectUrl, callbackResultPrefix: 'signingresult/' },
                });
            }
            return data;
        },
    );
